/* Organise existing descriptions without changing any product data. */
(() => {
  function enhance(root) {
    const source = root.querySelector('[data-sb-description]');
    const fallback = root.querySelector('[data-sb-description-panel]');
    if (!source || !fallback || root.dataset.enhanced) return;
    const labels = {
      info: 'Produktinfos', ingredients: 'Zutaten & Allergene',
      nutrition: 'Nährwertangaben', storage: 'Aufbewahrung & Hinweise',
      manufacturer: 'Hersteller & Lebensmittelunternehmer'
    };
    const groups = Object.fromEntries(Object.keys(labels).map(key => [key, []]));
    let current = 'info';
    const normal = text => text.replace(/\s+/g, '');
    function category(text) {
      if (/zutaten|allergen/i.test(text)) return 'ingredients';
      if (/nährwert|naehrwert|nährstoff/i.test(text)) return 'nutrition';
      if (/aufbewahr|lagerung|hinweise|warnhinweis|verpflichtende angaben/i.test(text)) return 'storage';
      if (/lebensmittelunternehmer|hersteller|inverkehrbringer/i.test(text)) return 'manufacturer';
      return 'info';
    }
    function walk(node) {
      if (node.nodeType === 3) { groups[current].push(node.cloneNode(true)); return; }
      if (node.nodeType !== 1) return;
      const text = node.textContent.trim();
      const isHeading = /^H[1-6]$/.test(node.tagName) ||
        (node.matches('.lmiv-product__entry-label') && !node.querySelector('div,p,table,section')) ||
        (node.tagName === 'P' && node.children.length === 1 && node.firstElementChild.matches('strong,b') && node.textContent.trim() === node.firstElementChild.textContent.trim());
      if (isHeading && text) {
        current = category(text);
        const heading = document.createElement('h3');
        // Preserve emphasis and all text from the original label.
        for (const child of node.childNodes) heading.append(child.cloneNode(true));
        groups[current].push(heading); return;
      }
      if (node.tagName === 'TABLE') {
        const key = /nährwert|brennwert|energie|kohlenhydrat/i.test(text) ? 'nutrition' : current;
        const wrapper = document.createElement('div'); wrapper.className = 'sb-table-scroll';
        wrapper.append(node.cloneNode(true)); groups[key].push(wrapper); return;
      }
      if (['DIV', 'SECTION', 'ARTICLE'].includes(node.tagName)) {
        for (const child of node.childNodes) walk(child);
      } else groups[current].push(node.cloneNode(true));
    }
    for (const child of source.childNodes) walk(child);
    const entries = Object.entries(groups).filter(([, nodes]) => nodes.some(node => node.textContent.trim() || (node.nodeType === 1 && node.querySelector('img'))));
    if (entries.length < 2) return; // Native accordion remains a complete, safe fallback.
    // Content may move between groups; compare text as a multiset to detect omissions.
    const before = [...normal(source.textContent)].sort().join('');
    const after = [...normal(entries.flatMap(([, nodes]) => nodes.map(n => n.textContent)).join(''))].sort().join('');
    if (before !== after) return;
    const fragment = document.createDocumentFragment();
    for (const [key, nodes] of entries) {
      const details = document.createElement('details'); details.className = 'sb-info-panel';
      const summary = document.createElement('summary'); summary.append(labels[key]);
      const sign = document.createElement('span'); sign.setAttribute('aria-hidden', 'true'); sign.textContent = '+'; summary.append(sign);
      const content = document.createElement('div'); content.className = 'rte sb-info-content'; content.append(...nodes);
      details.append(summary, content); fragment.append(details);
    }
    fallback.replaceWith(fragment); root.dataset.enhanced = 'true';
  }
  const init = () => document.querySelectorAll('[data-sb-information]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
